export default "__VITE_ASSET__39180fcf__"